<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "pompUsername":"aketest"
           },
            responseCode: {
                "data": {
                    "resources": [
                        {
                            "id": 10000000000,
                            "level": 1,
                            "name": "首页",
                            "orderVal": 1,
                            "permission": "INDEX",
                            "type": 1,
                            "url": "#"
                        },
                        {
                            "id": 20000000000,
                            "level": 1,
                            "name": "车场运营",
                            "orderVal": 2,
                            "permission": "PARK_MANAGE",
                            "type": 1,
                            "url": "#"
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "根据POMP用户账号获取POMP资源权限",
                t_url: this.commonUrls.test+"getPOMPAuthzResources",
                p_url: this.commonUrls.prod+"getPOMPAuthzResources",
                precondition: "授权商拥有的车场权限必须全包含POMP账号的车场权限，否则返回“车场权限不足”",
                fitSystem: "POMP",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'pompUsername', info2: '是', info3: 'String', info4: 'pomp登陆账号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'int', info4: '资源ID' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '资源名称' },
                        { info1: 'url', info2: '否', info3: 'String', info4: '资源地址' },
                        { info1: 'permission', info2: '是', info3: 'String', info4: '资源标识' },
                        { info1: 'type', info2: '是', info3: 'int', info4: '资源类型（1:menu，需要展示的菜单；其他为功能权限，页面根据权限标识决定是否展示）' },
                        { info1: 'iconStyle', info2: '否', info3: 'String', info4: '资源图标样式' },
                        { info1: 'parentId', info2: '是', info3: 'int', info4: '父资源ID' },
                        { info1: 'level', info2: '是', info3: 'int', info4: '层级（取值从1开始，逐层累加）' },
                        { info1: 'orderVal', info2: '是', info3: 'int', info4: '排序值，值越大显示越靠后' },
                        { info1: 'externalLinks', info2: '否', info3: 'String', info4: '外部链接地址' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/other/getPOMPAuthzResources.vue